/* unplugin-vue-components disabled */import { render } from "./mobileprompt.vue?vue&type=template&id=f4a0b0e2&scoped=true"
import script from "./mobileprompt.vue?vue&type=script&lang=js"
export * from "./mobileprompt.vue?vue&type=script&lang=js"

import "./mobileprompt.vue?vue&type=style&index=0&id=f4a0b0e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a0b0e2"]])

export default __exports__